import { jsx as _jsx } from "react/jsx-runtime";
import { H2 } from 'shared';
const DisabledEDS = () => {
    return (_jsx("div", { className: "text-center", children: _jsx(H2, { variant: "headline-medium", children: "Sorry this module is currently disabled." }) }));
};
export default DisabledEDS;
